import { render } from "./EditFactureSPage.vue?vue&type=template&id=20640d98&ts=true"
import script from "./EditFactureSPage.vue?vue&type=script&lang=ts"
export * from "./EditFactureSPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__